const SITE_BASE = (process.env.REACT_APP_BASE_URL || 'https://antologia.tech').replace(/\/$/, '');

/** Страница с формой «Обсудить задачу». */
export const DISCUSS_TASK_PAGE_PATH = '/discuss-ai';

/**
 * Ссылка на форму заявки (из письма чек-листа и CTA на сайте).
 * Балл чек-листа остаётся в URL для source_url при отправке заявки.
 */
export function buildDiscussTaskUrl({ score, maxScore, origin } = {}) {
  const params = new URLSearchParams();
  if (score != null) params.set('checklist_score', String(score));
  if (maxScore != null) params.set('checklist_max', String(maxScore));

  const base =
    origin ??
    (typeof window !== 'undefined' ? window.location.origin : null) ??
    SITE_BASE;

  const query = params.toString();
  return `${String(base).replace(/\/$/, '')}${DISCUSS_TASK_PAGE_PATH}${query ? `?${query}` : ''}`;
}
